import { __extends } from "tslib";
import { BitmapFilter } from './BitmapFilter';
import { assert, release, NumberUtilities } from '@awayfl/swf-loader';
import { BitmapFilterType } from './BitmapFilterType';
import { axCoerceString, Errors } from '@awayfl/avm2';
var BevelFilter = /** @class */ (function (_super) {
    __extends(BevelFilter, _super);
    function BevelFilter(distance, angle, highlightColor, highlightAlpha, shadowColor, shadowAlpha, blurX, blurY, strength, quality, type, knockout) {
        if (distance === void 0) { distance = 4; }
        if (angle === void 0) { angle = 45; }
        if (highlightColor === void 0) { highlightColor = 16777215; }
        if (highlightAlpha === void 0) { highlightAlpha = 1; }
        if (shadowColor === void 0) { shadowColor = 0; }
        if (shadowAlpha === void 0) { shadowAlpha = 1; }
        if (blurX === void 0) { blurX = 4; }
        if (blurY === void 0) { blurY = 4; }
        if (strength === void 0) { strength = 1; }
        if (quality === void 0) { quality = 1; }
        if (type === void 0) { type = 'inner'; }
        if (knockout === void 0) { knockout = false; }
        var _this = _super.call(this) || this;
        _this.filterName = 'bevel';
        _this.distance = distance;
        _this.angle = angle;
        _this.highlightColor = highlightColor;
        _this.highlightAlpha = highlightAlpha;
        _this.shadowColor = shadowColor;
        _this.shadowAlpha = shadowAlpha;
        _this.blurX = blurX;
        _this.blurY = blurY;
        _this.strength = strength;
        _this.quality = quality;
        _this.type = type;
        _this.knockout = knockout;
        return _this;
    }
    BevelFilter.FromUntyped = function (obj) {
        // obj.colors is an array of RGBA colors.
        // Here it contains exactly two color objects (spec might state it differently):
        //  - first maps to highlightColor and highlightAlpha;
        //  - second maps to shadowColor and shadowAlpha;
        release || assert(obj.colors && obj.colors.length === 2, 'colors must be Array of length 2');
        var highlightColor = obj.colors[0] >>> 8;
        var highlightAlpha = (obj.colors[0] & 0xff) / 0xff;
        var shadowColor = obj.colors[1] >>> 8;
        var shadowAlpha = (obj.colors[1] & 0xff) / 0xff;
        // type is derived from obj.onTop and obj.innerShadow
        // obj.onTop true: type is FULL
        // obj.inner true: type is INNER
        // neither true: type is OUTER
        var type = BitmapFilterType.OUTER;
        if (obj.onTop) {
            type = BitmapFilterType.FULL;
        }
        else if (obj.inner) {
            type = BitmapFilterType.INNER;
        }
        // obj.angle is represented in radians, the api needs degrees
        var angle = obj.angle * 180 / Math.PI;
        return new BevelFilter(obj.distance, angle, highlightColor, highlightAlpha, shadowColor, shadowAlpha, obj.blurX, obj.blurY, obj.strength, obj.quality, type, obj.knockout);
    };
    Object.defineProperty(BevelFilter.prototype, "distance", {
        get: function () {
            return this._distance;
        },
        set: function (value) {
            this._distance = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "angle", {
        get: function () {
            return this._angle;
        },
        set: function (value) {
            this._angle = +value % 360;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "highlightColor", {
        get: function () {
            return this._highlightColor;
        },
        set: function (value /*uint*/) {
            this._highlightColor = (value >>> 0) & 0xffffff;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "highlightAlpha", {
        get: function () {
            return this._highlightAlpha;
        },
        set: function (value) {
            this._highlightAlpha = NumberUtilities.clamp(+value, 0, 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "shadowColor", {
        get: function () {
            return this._shadowColor;
        },
        set: function (value /*uint*/) {
            this._shadowColor = (value >>> 0) & 0xffffff;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "shadowAlpha", {
        get: function () {
            return this._shadowAlpha;
        },
        set: function (value) {
            this._shadowAlpha = NumberUtilities.clamp(+value, 0, 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "blurX", {
        get: function () {
            return this._blurX;
        },
        set: function (value) {
            this._blurX = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "blurY", {
        get: function () {
            return this._blurY;
        },
        set: function (value) {
            this._blurY = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "knockout", {
        get: function () {
            return this._knockout;
        },
        set: function (value) {
            this._knockout = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "quality", {
        get: function () {
            return this._quality;
        },
        set: function (value /*int*/) {
            this._quality = NumberUtilities.clamp(value | 0, 0, 15);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "strength", {
        get: function () {
            return this._strength;
        },
        set: function (value) {
            this._strength = NumberUtilities.clamp(+value, 0, 255);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BevelFilter.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            value = axCoerceString(value);
            if (value === null) {
                this.sec.throwError('TypeError', Errors.NullPointerError, 'type');
            }
            else {
                if (value === BitmapFilterType.INNER || value === BitmapFilterType.OUTER) {
                    this._type = value;
                }
                else {
                    this._type = BitmapFilterType.FULL;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    BevelFilter.prototype.clone = function () {
        return new BevelFilter(this._distance, this._angle, this._highlightColor, this._highlightAlpha, this._shadowColor, this._shadowAlpha, this._blurX, this._blurY, this._strength, this._quality, this._type, this._knockout);
    };
    BevelFilter.prototype.toAwayObject = function () {
        return this;
    };
    // Called whenever the class is initialized.
    BevelFilter.classInitializer = null;
    // List of static symbols to link.
    BevelFilter.classSymbols = null; // [];
    // List of instance symbols to link.
    BevelFilter.instanceSymbols = null;
    return BevelFilter;
}(BitmapFilter));
export { BevelFilter };
